import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { PRODUCT_INFO } from '@hsc/common/constants/product-info';
import { FullStoryEventDirective } from '@directives/fullstory-event.directive';

@Component({
  selector: 'hsc-customers-get',
  imports: [CommonModule, FullStoryEventDirective],
  template: `
    <div class="w-full bg-white px-12 py-12.5">
      <div class="bolt-container">
        <div class="mb-8 flex items-center justify-center">
          <h2 class="bolt-heading-sm m-0 text-center">What {{ productInfo.name }} customers get</h2>
        </div>
        <div>
          <div class="grid grid-cols-3 gap-8">
            <div class="flex flex-col items-center rounded-lg p-4">
              <img
                src="/icons/servicing-icon.svg"
                alt="servicing-icon"
                class="mb-4 flex aspect-square h-12 w-12 items-center justify-center"
                hscFsEventName="Flexible Servicing Icon Clicked"
              />
              <div class="text-center">
                <h3 class="text-charcoal font-sans-serif mb-2 text-lg font-medium">Flexible servicing</h3>
                <p class="text-charcoal text-md font-sans-serif mb-2 font-normal">
                  Bring your own repair professional or use one from our trusted network.
                </p>
              </div>
            </div>
            <div class="flex flex-col items-center rounded-lg p-4">
              <img
                src="/icons/maintenance-icon.svg"
                alt="maintenance-icon"
                class="mb-4 flex aspect-square h-12 w-12 items-center justify-center"
                hscFsEventName="Maintenance Credit Icon Clicked"
              />
              <div class="text-center">
                <h3 class="text-charcoal font-sans-serif mb-2 text-lg font-medium">$150 maintenance reimbursement</h3>
                <p class="text-charcoal text-md font-sans-serif mb-2 font-normal">
                  Yearly reimbursement for a professional HVAC system tune-up, dryer vent cleaning, gutter cleaning,
                  chimney sweep or water heater maintenance.
                </p>
              </div>
            </div>
            <div class="flex flex-col items-center rounded-lg p-4">
              <img
                src="/icons/nationwide-icon.svg"
                alt="concierge-icon"
                class="mb-4 flex aspect-square h-12 w-12 items-center justify-center"
                hscFsEventName="Stability of Nationwide Icon Clicked"
              />
              <div class="text-center">
                <h3 class="text-charcoal font-sans-serif mb-2 text-lg font-medium">Designed by Nationwide</h3>
                <p class="text-charcoal text-md font-sans-serif mb-2 font-normal">
                  Rest assured knowing your home systems and appliances are protected.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class CustomersGet {
  readonly productInfo = PRODUCT_INFO;
}
